import React, { useEffect, useCallback } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

const Lightbox = ({ images, index, onIndexChange, onClose }) => {
  const total = images.length;
  const current = images[index];

  const prev = useCallback(
    (e) => {
      if (e) e.stopPropagation();
      onIndexChange((index - 1 + total) % total);
    },
    [index, total, onIndexChange]
  );

  const next = useCallback(
    (e) => {
      if (e) e.stopPropagation();
      onIndexChange((index + 1) % total);
    },
    [index, total, onIndexChange]
  );

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
      else if (e.key === 'ArrowLeft') prev();
      else if (e.key === 'ArrowRight') next();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose, prev, next]);

  if (!current) return null;

  return (
    <div
      className="fixed inset-0 z-[80] bg-black/90 flex items-center justify-center"
      onClick={onClose}
      data-testid="lightbox"
    >
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-white/80 hover:text-white transition-colors z-10"
        data-testid="lightbox-close"
        aria-label="Fermer"
      >
        <X className="h-8 w-8" />
      </button>

      {total > 1 && (
        <button
          onClick={prev}
          className="absolute left-3 md:left-6 text-white/70 hover:text-white bg-white/10 hover:bg-white/20 rounded-full p-2 transition-colors z-10"
          data-testid="lightbox-prev"
          aria-label="Photo précédente"
        >
          <ChevronLeft className="h-7 w-7" />
        </button>
      )}

      <figure
        className="max-w-[92vw] max-h-[88vh] flex flex-col items-center"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={current.url}
          alt={current.label || ''}
          className="max-w-[92vw] max-h-[80vh] object-contain rounded-lg shadow-2xl"
          data-testid="lightbox-image"
        />
        <figcaption className="mt-4 text-white/80 text-sm flex items-center gap-3">
          {current.label && (
            <span className="bg-emerald-600 px-2.5 py-0.5 rounded-full text-xs font-semibold text-white">
              {current.label}
            </span>
          )}
          <span>{index + 1} / {total}</span>
        </figcaption>
      </figure>

      {total > 1 && (
        <button
          onClick={next}
          className="absolute right-3 md:right-6 text-white/70 hover:text-white bg-white/10 hover:bg-white/20 rounded-full p-2 transition-colors z-10"
          data-testid="lightbox-next"
          aria-label="Photo suivante"
        >
          <ChevronRight className="h-7 w-7" />
        </button>
      )}
    </div>
  );
};

export default Lightbox;
